const initialState = {
  tiposVehiculo: [],
  colores: [],
  modelos: [],
  marcas: [],
  empresas: [],
  vehiculos: [],
  invitadoData: null,
};

const vehicleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "GET_TIPOS_VEHICULO_SIN_PAGINADO":
      return {
        ...state,
        tiposVehiculo: payload.data || [],
      };
    case "GET_COLORES_VEHICULO_SIN_PAGINADO":
      return {
        ...state,
        colores: payload.data || [],
      };
    case "GET_MODELOS_SIN_PAGINADO":
      return {
        ...state,
        modelos: payload.data || [],
      };
    case "GET_MARCAS_VEHICULO_SIN_PAGINADO":
      return {
        ...state,
        marcas: payload.data || [],
      };
    case "GET_EMPRESAS_SEGURO_VEHICULO_SIN_PAGINADO":
      return {
        ...state,
        empresas: payload.data || [],
      };
    case "GET_DATOS_MENU_PRINCIPAL_INVITADO":
      return {
        ...state,
        invitadoData: payload,
        vehiculos: payload.vehiculos || [],
      };
    default:
      return state;
  }
};

export default vehicleReducer;
